import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

import Button from '../common/button/Button';
import Spacer from '../common/spacer/Spacer';
import Text from '../common/text/Text';
import AllSteps from './AllSteps';
import CurrentStep from './CurrentStep';

import { useToggle } from '../../hooks/useToggle';
import Message, {getMessage} from '../common/message/Message';
import {generateURLParam} from '../../utils/Utils';

const ProgressListWrapper = props => {
    const {
        currentStep,
        hasUrl, // ensure URL is present before showing interview/release form buttons
        idVerified, // verified = show release form, unverified = show tax interview
        onButtonClick,
        offlinePayment,
        isCash,
        taxInterviewUrl,
        history,
        isValidationTaxProfile,
        messages,
        eventName,
        prizeId,
        isPrizeGated
    } = props;

    const [toggleState, toggle] = useToggle(false);

    const toggleCode = toggleState ? 'epic.esport.actions.collapse' : 'epic.esport.actions.expandAllSteps';

    const location = generateURLParam('tab', 'tax_profile');
    const args = [location];

    const __html = isValidationTaxProfile ? getMessage(messages, 'epic.esport.progress.title.pg', args) :
        getMessage(messages, 'epic.esport.progress.title.pg.invalid');

    const onClickTaxInterview = () => {
        if (taxInterviewUrl) {
            history.push('interview', {taxInterviewUrl: taxInterviewUrl, eventName, prizeId});
        }
    };

    if (isPrizeGated) {
        return (<Spacer paddingTop={8}>
            <Message as="p" code="epic.esport.content_gate.title" />
            <Message as="p" code="epic.esport.content_gate.info" args={['/competitive/support']} />
        </Spacer>);
    }

    return (
        <React.Fragment>
            <Spacer top={50} bottom={40} className="proglist">
                <Text right={16} size={18}>
                    <Message fragment code="epic.esport.progress.title" />
                </Text>
                <Button
                    variant={null}
                    className="proglist__toggle"
                    onClick={toggle}
                >
                    <Message fragment code={toggleCode} />
                </Button>
            </Spacer>
            {
                !isCash && <Spacer className="proglist-header-desc" bottom={40}>
                    <Text size={14}>
                        {
                            isValidationTaxProfile ? <div dangerouslySetInnerHTML={{__html}} /> :
                                <div onClick={onClickTaxInterview}>
                                    <span dangerouslySetInnerHTML={{__html}} />
                                </div>
                        }
                    </Text>
                </Spacer>
            }
            <div className="proglist__list">
                {!toggleState && (
                    <CurrentStep
                        hasUrl={hasUrl}
                        isRelease={idVerified}
                        offlinePayment={offlinePayment}
                        onButtonClick={onButtonClick}
                        isCash={isCash}
                        step={currentStep}
                    />
                )}
                {toggleState && (
                    <AllSteps
                        hasUrl={hasUrl}
                        isRelease={idVerified}
                        offlinePayment={offlinePayment}
                        onButtonClick={onButtonClick}
                        isCash={isCash}
                        step={currentStep}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

ProgressListWrapper.displayName = 'ProgressList';

ProgressListWrapper.propTypes = {
    currentStep: PropTypes.number,
    hasUrl: PropTypes.bool,
    idVerified: PropTypes.bool,
    offlinePayment: PropTypes.bool,
    onButtonClick: PropTypes.func,
    isCash: PropTypes.bool,
    isValidationTaxProfile: PropTypes.bool,
    taxInterviewUrl: PropTypes.string,
    messages: PropTypes.object,
    history: PropTypes.object,
    eventName: PropTypes.string,
    prizeId: PropTypes.string,
    isPrizeGated: PropTypes.bool
};

export const ProgressList = withRouter(ProgressListWrapper);
